import React, { forwardRef, useEffect } from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import {
  BottomSheet,
  theme,
  Text,
  Icon,
  Icons,
  typography,
  Button,
  ButtonType,
  Modal as ModalComponent,
} from "ui-components";
import { fontWeights } from "ui-components/dist/theme/typography";
import { Column, Row, Grid } from "ui-grid";
import { Spacer } from "../../spacer/spacer";

const webMaxWidth = 1200;
const tabMaxWidth = 992;
const mobileWebMaxWidth = 768;
const mobileMaxWidth = 576;

interface SliderAlertPopupProps {
  height?: number | string;
  children?: any;
  warningText?: string;
  supportingText?: string;
  leftButtonType?: ButtonType;
  rightButtonType?: ButtonType;
  onPressLeftButton?: any;
  onPressRightButton?: any;
  leftButtonText?: string;
  rightButtonText?: string;
  noteHead?: string;
  noteContent?: string;
  screenWidth?: number;
  showLeftButton?: boolean;
  showRightButton?: boolean;
  maxWidth?: string | number;
}

export const PopupWarning = forwardRef(
  (
    {
      children,
      height,
      warningText = "Warning Text",
      supportingText = "Supporting Text",
      leftButtonType = ButtonType.secondary,
      rightButtonType,
      onPressLeftButton = () => {},
      onPressRightButton = () => {},
      leftButtonText,
      rightButtonText,
      noteHead,
      noteContent,
      screenWidth = 0,
      showLeftButton = true,
      showRightButton = true,
      maxWidth,
    }: SliderAlertPopupProps,
    ref: any
  ) => {
    const { iconSize, colors } = theme;
    // const { width: screenWidth } = useWindowDimensions();
    let CustomTag = screenWidth <= mobileWebMaxWidth ? BottomSheet : ModalComponent;
    const styles = StyleSheet.create({
      iconContainer: {
        width: 40,
        alignSelf: "center",
        justifyContent: "center",
        paddingVertical: 15,
      },
      titleText: {
        fontFamily: "Lato_700Bold",
        fontWeight: fontWeights.Bold,
        color: screenWidth <= webMaxWidth ? colors.alert : colors.darkGrey,
        textAlign: "center",
      },
      supportingText: {
        fontWeight: fontWeights.Regular,
        color: colors.darkerGrey,
        textAlign: "center",
      },
      textContainer: {
        justifyContent: "center",
        alignItems: screenWidth <= webMaxWidth ? "center" : "flex-start",
        paddingVertical: 5,
      },
      buttonsContainer: {
        alignItems: "center",
        paddingVertical: 10,
        justifyContent: "center",
        // marginLeft: screenWidth <= webMaxWidth ? -15 : 0,
        // marginRight: screenWidth <= webMaxWidth ? -15 : 0,
      },
      noteHeading: {
        fontFamily: "Lato_700Bold",
        fontWeight: fontWeights.Bold,
        color: colors.alert,
        textAlign: "center",
      },
      noteText: {
        fontWeight: fontWeights.Regular,
        color: colors.darkerGrey,
        textAlign: "center",
      },
      noteContainer: {
        justifyContent: screenWidth <= webMaxWidth ? "center" : "flex-start",
        alignItems: screenWidth <= webMaxWidth ? "center" : "flex-end",
        paddingVertical: 5,
        flexDirection: screenWidth <= webMaxWidth ? "column" : "row",
      },
      textAlign: { textAlign: screenWidth <= webMaxWidth ? "center" : "left" },
      buttonStyle: { paddingVertical: screenWidth >= webMaxWidth ? 10 : 12 },
    });
    useEffect(() => {}, [screenWidth]);
    return (
      <CustomTag
        ref={ref}
        height={height || 400}
        showCloseIcon={screenWidth <= webMaxWidth ? true : false}
        containerStyle={{
          // width: "auto",
          width:
            screenWidth <= mobileWebMaxWidth
              ? "100%"
              : screenWidth >= mobileWebMaxWidth && screenWidth <= webMaxWidth
              ? 400
              : maxWidth
              ? maxWidth
              : 800,
        }}>
        <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ flexGrow: 1 }}>
          <View style={{}}>
            {screenWidth <= webMaxWidth && (
              <View style={styles.iconContainer}>
                <View>
                  <Icon name={Icons.warning} size={iconSize.large} color={colors.alert} />
                </View>
              </View>
            )}

            <View style={styles.textContainer}>
              <Text style={[typography.title2, styles.titleText, styles.textAlign]}>
                {warningText}
              </Text>
            </View>
            <View style={styles.textContainer}>
              <Text style={[typography.subHeading, styles.supportingText, styles.textAlign]}>
                {supportingText}
              </Text>
            </View>

            <View style={styles.noteContainer}>
              {noteHead && (
                <Text style={[typography.subHeading, styles.noteHeading, styles.textAlign]}>
                  {noteHead}
                </Text>
              )}
              {noteContent && (
                <Text style={[typography.body, styles.noteText, styles.textAlign]}>
                  {" "}
                  {noteContent}
                </Text>
              )}
            </View>
          </View>
          <View style={{ flex: 1 }} />
          <Spacer />
          <Grid>
            <Row justifyContent={{ md: "center" }}>
              {showLeftButton && (
                <Column span={{ xs: 12, sm: true, lg: true }}>
                  <Button
                    text={leftButtonText}
                    mode={rightButtonText}
                    onPress={onPressLeftButton}
                    type={leftButtonType}
                    borderColor={theme.colors.alert}
                    textStyle={{ color: theme.colors.alert }}
                    style={styles.buttonStyle}
                    testID={"popup-yes-button"}
                    accessibilityLabel={"popup-yes-button"}
                  />
                </Column>
              )}
              <Spacer />
              {showRightButton && (
                <Column span={{ xs: 12, sm: true, lg: true }}>
                  <Button
                    text={rightButtonText}
                    mode="contained"
                    onPress={onPressRightButton}
                    type={rightButtonType}
                    style={styles.buttonStyle}
                    testID={"popup-cancel-button"}
                    accessibilityLabel={"popup-cancel-button"}
                  />
                </Column>
              )}
            </Row>
          </Grid>
        </ScrollView>
      </CustomTag>
    );
  }
);
